module.exports = __webpack_public_path__ + "static/media/replace_tag.6a29de7c.png";